import type { OsResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { OsNameWithId } from '@ingenico/react-configuration-generator';
import { toString } from 'lodash-es';

export function mapOsListResponseApiToOsVersionAndNameList({ data }: OsResourceListResponseV2Api): OsNameWithId[] {
  return data.map((item) => ({
    compatibleDeviceFamilyNames: item.compatibleDeviceFamilyNames ?? [],
    id: toString(item.id),
    isDeprecated: item.status === 'DEPRECATED',
    logoAsset: item.assets.find((asset) => ['IMAGE', 'LOGO'].includes(toString(asset.type))) ?? undefined,
    value: toString(item.name),
  }));
}
